"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var data;
        (function (data_1) {
            var group;
            (function (group) {
                class InitArgs {
                    constructor() {
                        this.formElements = [];
                        this.selectedFormId = appn.emptyString;
                        this.entryId = appn.emptyString;
                        this.groupDataName = appn.emptyString;
                        this.dataGroupDataTable = appn.emptyString;
                        this.repeatIndex = -1;
                    }
                }
                let _initArgs;
                let _datatable = null;
                function init(args) {
                    _initArgs = args;
                    addEvents();
                    createDataTable();
                }
                group.init = init;
                function addEvents() {
                    $(document).on('click', 'a[id^="viewGroup_"]', function (e) {
                        e.preventDefault();
                        const link = $(this);
                        const groupIndex = Number(link.attr('id').split('_')[2]);
                        const href = `${link.attr('href')}?repeatIndex=${groupIndex}`;
                        return appn.ui.popup(href);
                    });
                }
                function createDataTable() {
                    _datatable = appn.dataTable.create('.dataTable', {
                        sDom: appn.dataTable.genSDom(0, 0, 0),
                        sAjaxSource: _initArgs.dataGroupDataTable,
                        scrollX: '100%',
                        fnServerData: function (data) {
                            data.push(appn.dataTable.getStateOrDefault('sCustom_0', _initArgs.selectedFormId), appn.dataTable.getStateOrDefault('sCustom_1', _initArgs.entryId), appn.dataTable.getStateOrDefault('sCustom_2', _initArgs.groupDataName), appn.dataTable.getStateOrDefault('sCustom_3', _initArgs.repeatIndex));
                        },
                        aoColumns: getDtColConfiguration(),
                        searching: false,
                        fnInitComplete: function () {
                            appn.saveMeState.init(function () {
                                _datatable.fnDraw(false);
                            }, function () {
                                _datatable.fnDraw(false);
                            }, '.dataTables_filter');
                        },
                        fnDrawCallback: function () {
                            appn.dialog.singleEntryExport.init();
                            $('td').on('click', 'a#viewMedia', function (event) {
                                event.preventDefault();
                                appn.dialog.viewMediaFromElement($(this));
                            });
                        }
                    });
                }
                function getDtColConfiguration() {
                    const columns = [];
                    for (let i = 0; i < _initArgs.formElements.length; i++)
                        columns.push({
                            bSortable: false,
                            sWidth: '200px',
                            sName: _initArgs.formElements[i].name,
                            sDefaultContent: appn.emptyString
                        });
                    return columns;
                }
            })(group = data_1.group || (data_1.group = {}));
        })(data = views.data || (views.data = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
